import { useDispatch } from 'react-redux'
import {
  Text,
  Box,
  Flex,
  Icon,
  IconButton,
  Image,
  Link,
  Button,
  Tooltip
} from '@chakra-ui/react'

import Can from '../../auth/Can'
import { DeleteIcon } from '../Shared/Icons'
import UploadPDF from '../Shared/UploadPDF'
import { getUrlPdf } from '../../store/slices/fileUpload'
import addFileIcon from '../../assets/images/addFile.svg'

// Carga de PDF del cliente (solo administrador)
const ClientPdfUpload = ({ formik }) => {
  const dispatch = useDispatch()
  const pdf = formik.values.pdf

  const pdfUpload = async (formPDF) => {
    try {
      const response = await dispatch(getUrlPdf(formPDF))
      if (response) {
        formik.setFieldValue('pdf', response)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const removePdf = () => {
    formik.setFieldValue('pdf', '')
  }

  const getFilename = (url) => url.substr(url.lastIndexOf('/') + 1)

  return (
    <Can
      availableTo={[1]}
      yes={() => (
        <>
          <Text fontSize="20px" fontWeight="bold" color="#36355F" pt="50px">
            Documento PDF
          </Text>
          {pdf ? (
            <Flex
              w="100%"
              align="center"
              gap={4}
              p={3}
              bg="#FFFFFF"
              border="1px solid"
              borderColor="#E2E8F0"
              borderRadius="lg"
              boxShadow="sm"
              transition="all 0.2s ease"
              _hover={{ boxShadow: 'md', borderColor: '#59BABA' }}
            >
              <Flex
                align="center"
                justify="center"
                boxSize="44px"
                borderRadius="md"
                bg="#D1F1F5"
                flexShrink={0}
              >
                <Image src={addFileIcon} boxSize="22px" />
              </Flex>
              <Box flex="1" minW={0}>
                <Text fontSize="12px" color="#718096">
                  Documento cargado
                </Text>
                <Link
                  href={pdf}
                  isExternal
                  color="#36355F"
                  fontWeight="bold"
                  fontSize="15px"
                  noOfLines={1}
                  wordBreak="break-all"
                  _hover={{ color: '#59BABA', textDecoration: 'underline' }}
                >
                  {getFilename(pdf)}
                </Link>
              </Box>
              <Button
                as={Link}
                href={pdf}
                isExternal
                size="sm"
                variant="outline"
                color="#59BABA"
                borderColor="#59BABA"
                flexShrink={0}
                _hover={{ bg: '#D1F1F5', textDecoration: 'none' }}
              >
                Ver
              </Button>
              <Tooltip label="Eliminar PDF" hasArrow>
                <IconButton
                  aria-label="Eliminar PDF"
                  icon={<Icon fontSize="20" as={DeleteIcon} />}
                  variant="ghost"
                  colorScheme="red"
                  flexShrink={0}
                  onClick={removePdf}
                />
              </Tooltip>
            </Flex>
          ) : (
            <UploadPDF pdfUpload={pdfUpload} label="Agregar PDF" />
          )}
        </>
      )}
    />
  )
}

export default ClientPdfUpload
